import React from 'react';
const tomes = [{
  emoji: '💰',
  title: 'Tomo 1 — Ingeniería del Dojo',
  desc: '60 páginas · Finanzas, cuotas, precios y gestión económica real del dojo'
}, {
  emoji: '🎯',
  title: 'Tomo 2 — Pedagogía de Retención',
  desc: '60 páginas · Sistema anti-deserción, seguimiento y fidelización de alumnos'
}, {
  emoji: '📣',
  title: 'Tomo 3 — Marketing Guerrero',
  desc: '60 páginas · Captación orgánica, redes sociales y alianzas locales sin gastar'
}, {
  emoji: '🥋',
  title: 'Tomo 4 — Programas de Grados Pro',
  desc: '60 páginas · Planificación técnica de 48 semanas para cualquier disciplina'
}, {
  emoji: '🤝',
  title: 'Tomo 5 — Psicología del Cierre',
  desc: '60 páginas · Scripts y sistema para convertir consultas en inscripciones'
}, {
  emoji: '👑',
  title: 'Tomo 6 — Liderazgo y Staff',
  desc: '60 páginas · Formación de monitores, delegación y escalabilidad del dojo'
}];
const includes = ['Marco teórico de gestión profesional por área', 'Scripts listos para copiar y usar hoy', 'Planillas y contratos editables en PDF', 'Checklists de implementación por tomo', 'Protocolos de retención y seguimiento de alumnos', 'Guiones para hablar con familias y nuevos alumnos', 'Sistema de cobros y control financiero mensual', '100% adaptado a la realidad del instructor argentino'];
export function WhatYouGet() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-506">
      <div className="mx-auto max-w-4xl" data-id="element-507">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center leading-10 text-gray-900 m-0 mb-8" data-id="element-508">
          Lo que <span className="text-red-500" data-id="element-509">recibís</span>
        </h2>

        {/* 6 Tomos Card */}
        <div className="mx-auto max-w-3xl mb-8" data-id="element-510">
          <div className="bg-white border border-red-200 rounded-xl p-5 shadow-sm" data-id="element-511">
            <h3 className="text-lg font-black text-red-500 m-0 mb-1" data-id="element-512">
              🥋 LOS 6 TOMOS
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-513">
              Para instructores y dueños de dojos de cualquier disciplina marcial
            </p>

            <div className="space-y-3" data-id="element-514">
              {tomes.map(tome => <div key={tome.title} className="flex items-center gap-2 text-gray-900" data-id="element-515">
                  <span className="text-lg" data-id="element-516">{tome.emoji}</span>
                  <div className="flex-1 text-sm" data-id="element-517">
                    <span className="font-bold" data-id="element-518">{tome.title}</span>{' '}
                    <span className="text-gray-500" data-id="element-519">{tome.desc}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Each Tome Includes */}
        <div className="mx-auto max-w-3xl bg-red-50 text-center border border-red-200 rounded-xl p-6 shadow-sm" data-id="element-520">
          <h3 className="text-lg font-black text-red-500 m-0 mb-4" data-id="element-521">
            Cada tomo incluye:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-522">
            {includes.map(item => <div key={item} className="flex items-start gap-2 text-left" data-id="element-523">
                <span className="shrink-0 font-bold text-red-500 text-sm" data-id="element-524">
                  ✅
                </span>
                <span className="text-xs text-gray-900" data-id="element-525">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}